/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type GetDrBillsForCustomerSortField =
  (typeof GetDrBillsForCustomerSortField)[keyof typeof GetDrBillsForCustomerSortField];

export const GetDrBillsForCustomerSortField = {
  Datum: "Datum",
  Abrechnungsmonat: "Abrechnungsmonat",
  Rechnungsnummer: "Rechnungsnummer",
  Betrag: "Betrag",
  Status: "Status",
} as const;
